import type {AxiosError} from 'axios';
import {axiosInstance} from './axiosInstance';
import {isPreSessionAuthRequest} from './preSessionAuthRequest';

type UnauthorizedHandler = () => void;

let handler: UnauthorizedHandler | null = null;
let interceptorRegistered = false;

function requestHadAuthorization(error: AxiosError): boolean {
	const headers = error.config?.headers;

	if (!headers) {
		return false;
	}

	const value =
		typeof headers.get === 'function'
			? headers.get('Authorization') ?? headers.get('authorization')
			: (headers as {Authorization?: unknown; authorization?: unknown}).Authorization ??
				(headers as {authorization?: unknown}).authorization;

	return typeof value === 'string' && value.length > 0;
}

function registerUnauthorizedInterceptor(): void {
	if (interceptorRegistered) return;

	interceptorRegistered = true;

	axiosInstance.interceptors.response.use(
		(response) => response,
		(error: AxiosError) => {
			// Временный Bearer на шагах входа не сессия: 401 там — неверный пароль, не разлогин.
			if (
				handler &&
				error.response?.status === 401 &&
				requestHadAuthorization(error) &&
				!isPreSessionAuthRequest(error.config?.url, error.config?.baseURL)
			) {
				handler();
			}

			return Promise.reject(error);
		},
	);
}

export function setUnauthorizedHandler(next: UnauthorizedHandler | null): void {
	handler = next;
	registerUnauthorizedInterceptor();
}
